import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loader from '../common/Loader';

function AdminRoute({ children }) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <Loader />;
  }

  if (currentUser && currentUser.isAdmin) {
    return children;
  }

  return <Navigate to="/" replace />;
}

export default AdminRoute;